module.exports = __webpack_public_path__ + "img/transfer14.b0c1d8bf.jpeg";